export default __webpack_public_path__ + "static/media/m1.49dc7811.png";